import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, UptimeResponse } from "../../lib/api";

export function UptimePage() {
  const [period, setPeriod] = useState(30);
  const { data, isLoading } = useQuery({
    queryKey: ["uptime", period],
    queryFn: () => api.get<UptimeResponse>(`/api/v1/admin/uptime?period_days=${period}`),
    refetchInterval: 30_000,
  });

  return (
    <div style={{ padding: "24px 32px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <h1 style={{ fontSize: 22, color: "#1a365d", margin: 0 }}>Аптайм реєстрів</h1>
        <select value={period} onChange={(e) => setPeriod(parseInt(e.target.value))} style={inp}>
          <option value={7}>останні 7 днів</option>
          <option value={30}>останні 30 днів</option>
          <option value={90}>останні 90 днів</option>
        </select>
      </div>

      {isLoading && <div>Завантаження…</div>}

      {data && (
        <div style={{ background: "white", borderRadius: 6, border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ background: "#ebf4ff", textAlign: "left", color: "#2c5282" }}>
                <th style={th}>Source</th>
                <th style={th}>Аптайм</th>
                <th style={th}>Усього run-ів</th>
                <th style={th}>Success / Partial / Failed</th>
                <th style={th}>Сер. час</th>
                <th style={th}>Останній run</th>
              </tr>
            </thead>
            <tbody>
              {data.sources.length === 0 && (
                <tr><td colSpan={6} style={{ padding: 24, textAlign: "center", color: "#a0aec0" }}>
                  Жодних запусків за {period} днів
                </td></tr>
              )}
              {data.sources.map((s) => (
                <tr key={s.source} style={{ borderTop: "1px solid #e2e8f0" }}>
                  <td style={td}><code>{s.source}</code></td>
                  <td style={td}>
                    <strong style={{ color: s.uptime_pct >= 95 ? "#48bb78" : s.uptime_pct >= 80 ? "#ed8936" : "#e53e3e" }}>
                      {s.uptime_pct.toFixed(1)}%
                    </strong>
                  </td>
                  <td style={td}>{s.total_runs}</td>
                  <td style={td}>
                    <span style={{ color: "#48bb78" }}>{s.success}</span> /
                    <span style={{ color: "#ed8936" }}> {s.partial}</span> /
                    <span style={{ color: "#e53e3e" }}> {s.failed}</span>
                  </td>
                  <td style={td}>{s.avg_duration_seconds ? `${s.avg_duration_seconds}s` : "—"}</td>
                  <td style={td}>
                    {s.last_run_at ? new Date(s.last_run_at).toLocaleString("uk-UA") : "—"}
                    {s.last_status && <span style={{ marginLeft: 8, fontSize: 11, color: "#a0aec0" }}>({s.last_status})</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const th: React.CSSProperties = { padding: "10px 12px", fontWeight: 600 };
const td: React.CSSProperties = { padding: "8px 12px" };
const inp: React.CSSProperties = { padding: "7px 10px", fontSize: 13, border: "1px solid #cbd5e0", borderRadius: 4 };
